import ModalWrapper, { modalStore, addModal, clearModals } from './ModalWrapper'

export { modalStore, addModal, clearModals };
export default ModalWrapper;